import React, { useState,} from "react";
import { StyleSheet, TouchableOpacity } from 'react-native';

import { View } from '../../../components/Themed';
import { Entypo } from '@expo/vector-icons';
import Utilities from "../~Utilities/Utilities";
import { FontInfo } from "../~Utilities/Constants";
import { Data } from "../~Utilities/Data";
import QB from "./QB";
import OBNakedText from "../C_Text/OBNakedText";
import OBChange from "../C_Text/OBChange";
import { ConnectionMkt } from "../~Utilities/Connection";
// import OB from "./OB";
import OrderWoOrder from "../C_Popups/OrderWoOrder";

/*   -------------------------------------------------------------------   */

export interface IOBBottomInfo
{
  oData     : Data;

  qbRef?    : React.RefObject<QB>;
  //Remove    : (sToken: string)=>void;
  bindEvent : (onEvent    : (() => void),
               bSubscribe : boolean) => void,

  visible : boolean;             
}

/*   ====================================================================   */

export default class OBBottom extends React.Component<IOBBottomInfo>
  {
  // const [m_index, setIndex]               = useState(iIndex);
  public orderWoOrderRef? : OrderWoOrder | null;

  /*   -------------------------------------------------------------------   */

  state = {visible: false};

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state     = {visible: this.props.visible};
  this.Show      = this.Show.bind(this);
  this.Hide      = this.Hide.bind(this);
  }

/*   -------------------------------------------------------------------   */

 Show()
 {
    this.setState({visible : true});
 }

 /*   --------------------------------------------------------------------   */

 Hide()
 {
    this.setState({visible : false});
 }

 /*   --------------------------------------------------------------------   */

  render()
  {
    //this.props.onBlue(this.state.m_index);

    return(
      <View style={{display:!this.state.visible?'none':'flex', flexDirection:'column', backgroundColor:'transparent'}}>
      <OrderWoOrder
      ref={node => { this.orderWoOrderRef = node}}
      oData={this.props.oData}
      qbRef={this.props.qbRef}
      bindEvent={this.props.bindEvent}
      />

      <OBNakedText bindEvent={this.props.bindEvent}
                   getStyle={()=>{return([FontInfo.appStyles.txt_bold, styles.row_mode, {marginLeft:0, color: Utilities.getModeColor(this.props.oData.mode)}])}}
                   getText={()=>{return(this.props.oData.mode)}}
                   />

      </View>
  
    );
  }

}

/*   ---------------------------------------------------------------------   */

const styles = StyleSheet.create({

  row_mode: {
    alignSelf:'center',
    color: 'grey',
    marginTop:2,
    paddingRight: ConnectionMkt.DEVICE_NAME == ConnectionMkt.DEVICE_WEB? 15 : 0,
    },

});



